import {
  CoinbaseWalletConnector,
  Config,
  MetamaskConnector,
  Chain,
} from "@usedapp/core";
import { ethers } from "ethers";

export const Base: Chain = {
  chainId: 8453,
  chainName: "Base",
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: "0xcA11bde05977b3631167028862bE2a173976CA11",
  rpcUrl: "https://mainnet.base.org",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  blockExplorerUrl: "https://basescan.org",
  getExplorerAddressLink: (address: string) =>
    `https://basescan.org/address/${address}`,
  getExplorerTransactionLink: (transactionHash: string) =>
    `https://basescan.org/tx/${transactionHash}`,
};

export const BaseSepolia: Chain = {
  chainId: 84532,
  chainName: "Base Sepolia",
  isTestChain: true,
  isLocalChain: false,
  multicallAddress: "0xcA11bde05977b3631167028862bE2a173976CA11",
  rpcUrl: "https://sepolia.base.org",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  blockExplorerUrl: "https://sepolia.basescan.org",
  getExplorerAddressLink: (address: string) =>
    `https://sepolia.basescan.org/address/${address}`,
  getExplorerTransactionLink: (transactionHash: string) =>
    `https://sepolia.basescan.org/tx/${transactionHash}`,
};

// ============================================
// NETWORK TOGGLE: Change this line to rollback
// Mainnet: ActiveNetwork = Base
// Testnet: ActiveNetwork = BaseSepolia
// ============================================
export const ActiveNetwork: Chain = Base;

// Safe Global app URL prefix (e.g. "base" for mainnet, "base-sepolia" for testnet)
export const SAFE_NETWORK_PREFIX =
  ActiveNetwork === Base ? "base" : "base-sepolia";

export const config: Config = {
  readOnlyChainId: ActiveNetwork.chainId,
  readOnlyUrls: {
    [ActiveNetwork.chainId]: ActiveNetwork.rpcUrl!,
  },
  networks: [ActiveNetwork],
  multicallVersion: 1 as const,
  connectors: {
    metamask: new MetamaskConnector(),
    coinbase: new CoinbaseWalletConnector(),
  },
};

(window as any).ethers = ethers;

